<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <template>

        <b-form-group
          :label="$t('Search')"
          label-for="mc-box-title"
        >
          <validation-provider
            #default="{ errors }"
            name="Search"
            rules="required"
          >
            <b-form-input
              v-model="searchValue"
              :state="errors.length > 0 ? false:null"
              :placeholder="$t('Search...')"
              @input="autoTitleFlag = false"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Question Names -->
        <b-form-group
          :label="$t('Search In')"
          label-for="mc-box-questionNames"
        >
          <v-select
            id="mc-box-questionNames"
            v-model="searchQuestions"
            :options="optionQuestion"
            label="questionText"
            :placeholder="$t('Search in all')"
            multiple
          />
        </b-form-group>

      </template>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormInput,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      searchValue: null,
      searchQuestions: [],
      questionData: null,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      },
    },
    optionQuestion() {
      const qlist = []
      if (this.item.boxConfig.questionNames && this.questionData) {
        if (this.item.boxConfig.type === 'data') {
          qlist.push({ questionName: 'orjref', questionText: 'ORJREF' })
        }

        this.questionData.forEach(q => {
          if ((this.item.boxConfig.questionName && this.item.boxConfig.questionName === q.questionName) || this.item.boxConfig.questionNames.includes(q.questionName) || (this.item.boxConfig.infoQuestionNames && this.item.boxConfig.infoQuestionNames.includes(q.questionName))) {
            qlist.push({ questionName: q.questionName, questionText: q.questionText })
          }
        })
      }
      return qlist
    },
  },
  async created() {
    this.getQuestionOptions()
  },
  methods: {
    getQuestionOptions() {
      if (this.item.projectId) {
        useJwt.axiosIns.get(`question/${this.item.projectId}/shortlist`).then(response => {
          this.questionData = response.data
        })
      }
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$emit('submit', { boxId: this.item.id, searchQuestions: this.searchQuestions.length ? this.searchQuestions : this.optionQuestion, searchValue: this.searchValue })
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
